
/* injects from baggage-loader */

'use strict';

export default class RaiseSubmittedConfirmationController {

	constructor($log) {
		'ngInject';

		this.$log = $log;

	}

	$onInit() {

	}

}



// WEBPACK FOOTER //
// ./src/app/pages/raise-submitted-confirmation/raise-submitted-confirmation.controller.js